// import React from "react";
// import {Container, Row, Col} from "react-bootstrap";
// import Slider from "react-slick";
// import Img17 from "../src/assets/images/17.png";
// import Img18 from "../src/assets/images/18.png";
// import Img19P from "../src/assets/images/19.png";
// import Img19J from "../src/assets/images/19.jpg";
// import Img20 from "../src/assets/images/20.jpg";
// import Logo from "../src//assets/images/logo.png";
// import footBack from "../src/assets/images/foot.webp";
// import {
//   Layout,
//   Menu,
//   Avatar,
//   Space,
//   Dropdown,
//   Segmented,
//   Card,
//   Image,
//   Button,
//   message,
//   Badge,
// } from "antd";
// import {
//   UserOutlined,
//   AppstoreOutlined,
//   BarsOutlined,
//   EditOutlined,
//   HeartFilled,
//   ShoppingCartOutlined,
//   HeartOutlined,
//   SettingOutlined,
//   LogoutOutlined,
// } from "@ant-design/icons";
// import {FaFacebook, FaTelegram} from "react-icons/fa";
// import {FaInstagram} from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux"
// import { Translate, selectCount, selectLang, updateCount } from "./app/store/reducers/main/mainReducer";
// import { Link } from "react-router-dom";

// // import { Dropdown, Space, Divider, Button, theme } from 'antd';
// const {Header, Content, Footer} = Layout;

// const items = new Array(4).fill(null).map((_, index) => ({
//   key: index + 1,
//   label: `Home ${index + 1}`,
// }));
// const App = () => {
//   const settings = {
//     // dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     nextArrow: <SampleNextArrow />,
//     prevArrow: <SampleNextArrow />,
//     cssEase: "linear",
//   };
//   // test count redux
//   const lang = useSelector(selectLang)
//   const t = Translate
//   const dispatch = useDispatch()
//   const count = useSelector(selectCount)
//   console.log("count", count)

//   function SampleNextArrow() {
//     return <div style={{display: "none"}} />;
//   }

//   const [messageApi, contextHolder] = message.useMessage();
//   const success = () => {
//     messageApi.open({
//       type: 'success',
//       content: 'This is a success message',
//     });
//   };

//   const images = [
//     {
//       img: Img17,
//     },
//     {
//       img: Img18,
//     },
//     {
//       img: Img19P,
//     },
//     {
//       img: Img19J,
//     },
//     {
//       img: Img20,
//     },
//   ];

//   const itemsDrop = [
//     {
//       key: "1",
//       label: (
//         <Link
//           to="/profile"
//           style={{fontSize: "17px"}}
//         >
//           Profile
//         </Link>
//       ),
//       icon: <UserOutlined style={{fontSize: "18px", color: "black"}} />,
//     },
//     {
//       key: "2",
//       label: (
//         <Link
//           to="/settings"
//           style={{fontSize: "17px"}}
//         >
//           Settings
//         </Link>
//       ),
//       icon: <SettingOutlined style={{fontSize: "18px", color: "black"}} />,
//     },
//     {
//       key: "3",
//       color: "red",
//       label: (
//         <Link
//           to="/logout"
//           style={{fontSize: "17px", color: "red"}}
//         >
//           Logout
//         </Link>
//       ),
//       icon: <LogoutOutlined style={{fontSize: "18px", color: "red"}}/>,
//     },
//   ];

//   return (
//     <Layout>
//       <Header
//         style={{
//           display: "flex",
//           alignItems: "center",
//           // justifyContent: "center",
//           justifyContent: "space-between",
//           background: "white",
//           textUnderlinePosition: "unset",

//           position: "sticky",
//           top: 0,
//           zIndex: 1,
//         }}
//       >
//         {/* <div className="demo-logo" /> */}
//         <Link to="/">
//         <Space size={20} wrap className="">
//           <Avatar size={44} src={<img src={Logo} alt="avatar" />} />
//         </Space>
//         </Link>
//         {/* <Menu
//           // theme="dark"
//           mode="horizontal"
//           defaultSelectedKeys={["2"]}
//           items={items}
//           style={{
//             flex: 1,
//             justifyContent: "center",
//             minWidth: 0,
//           }}
//         /> */}

//         <Space size={20} style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}>
//         <Link to="/favorites">
//         <Badge count={count}>
//           {/* <Avatar shape="square" size="large" /> */}
//         <HeartOutlined key="favorite" style={{fontSize: "30px", display: "inline"}} />
//         </Badge>
//         </Link>
//         <Link to="/cart">
//         <Badge count={count}>
//         <ShoppingCartOutlined
//           key="shopping"
//           style={{fontSize: "30px", color: "gray", display: "inline"}}
//         />
//         </Badge>
//         </Link>
//         <Dropdown
//           menu={{
//             items: itemsDrop,
//           }}
//           dropdownRender={(menu) => {
//             return <div>{React.cloneElement(menu)}</div>;
//           }}
//         >
//           <Space>
//             {/* <Avatar src={<img src={Img18} alt="avatar" />} /> */}
//             <Avatar size={40} icon={<UserOutlined />} />
//           </Space>
//         </Dropdown>
//         </Space>
//       </Header>
//       <Content>
//         <div
//           style={{
//             background: "white",
//             minHeight: 280,
//           }}
//         >
//           {contextHolder}
//           <Button onClick={() => {
//             dispatch(updateCount(count + 1))
//             success()}}>{t(lang, "test_version")} {count}</Button>
//           <Container fluid className="p-0">
//             <Slider {...settings}>
//               {images?.map((item, index) => {
//                 return (
//                   <div key={index}>
//                     <img
//                       src={item?.img}
//                       style={{
//                         width: "100%",
//                         height: "80vh",
//                         backgroundRepeat: "no-repeat",
//                         backgroundPosition: "center center",
//                       }}
//                     />
//                   </div>
//                 );
//               })}
//             </Slider>
//           </Container>
//         </div>

//         <Container>
//           <Row className="my-5">
//             <Col xs={12}>
//               <h1 className="text-center">Collection</h1>
//             </Col>

//             <Col>
//               <Segmented
//                 options={[
//                   {
//                     value: "List",
//                     icon: <BarsOutlined />,
//                   },
//                   {
//                     value: "Kanban",
//                     icon: <AppstoreOutlined />,
//                   },
//                 ]}
//               />
//             </Col>
//             <Col xs={12} className="border border-2  mt-3 py-3">
//               <Card
//                 style={{
//                   width: 300,
//                 }}
//                 cover={
//                   <Image
//                     // width={200}
//                     height={200}
//                     src={Img17}
//                   />
//                 }
//                 actions={[
//                   <ShoppingCartOutlined
//                     key="shopping"
//                     style={{fontSize: "25px", color: "gray"}}
//                   />,
//                   <EditOutlined
//                     key="edit"
//                     style={{fontSize: "25px", color: "orange"}}
//                   />,
//                   <HeartFilled
//                     key="favorite"
//                     style={{fontSize: "25px", color: "red"}}
//                   />,
//                 ]}
//               >
//                 <Card.Meta
//                   title="Flower shape"
//                   // description="Monaliza"
//                 />
//                 <h4 className="p-0 mt-1 fw-bold">$32.00</h4>
//                 <span>Time: 6:08PM 1.25.2024</span>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       </Content>
//       <Footer
//         style={{
//           // textAlign: "center",
//           backgroundImage: `url(${footBack})`,
//           color: "white",
//           // border: "10px  solid",
//           // borderRadius: "30px",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "space-around",
//           height: "280px",
//           width: "100%",
//         }}
//       >
//         <Avatar size={70} src={Logo} />
//         <div
//           style={{
//             minWidth: 200,
//             margin: "15px 0",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <FaTelegram size={35} style={{color: "#229ED9"}} />
//           <FaInstagram size={35} style={{color: "#C13584"}} />
//           <FaFacebook size={35} style={{color: "#3a589b"}} />
//         </div>
//         Monaliza ©{new Date().getFullYear()} Created by LorD
//       </Footer>
//     </Layout>
//   );
// };
// export default App;












































import React, { useEffect, useState } from "react";
import {Container, Row, Col} from "react-bootstrap";
import footBack from "../src/assets/images/foot.webp";
import {
  Layout,
  Segmented,
  message,
} from "antd";
import {
  AppstoreOutlined,
  BarsOutlined,
} from "@ant-design/icons";
import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "./components/header/Navbar";
import HeaderSlider from "./components/common/HeaderSlider";
import Footers from "./components/footer/Footers";
import ProductList from "./pages/main/product/ProductList";
import { useDispatch } from 'react-redux';
import { initializeAsync, logoutAsync } from "./app/store/reducers/auth/authReducer";
import EventBus from "./app/eventBus/EventBus";
import { AUTHENTICATION_LOGOUT_SUCCESS, PROFILE_IMAGE_SUCCESS, PROFILE_SUCCESS } from "./app/eventBus/authEvents/authEvents";
import axios from "axios"

const {Header, Content, Footer} = Layout;




const App = () => {
  // const [shape, setShape] = useState('List')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  
  useEffect(() => {
    dispatch(initializeAsync())

    const profileHandler = EventBus.on(PROFILE_SUCCESS, () => {
        dispatch(initializeAsync())
    })
    const profileImageHandler = EventBus.on(PROFILE_IMAGE_SUCCESS, () => {
        dispatch(initializeAsync())
    })
    const logoutHandler = EventBus.on(AUTHENTICATION_LOGOUT_SUCCESS, () => {
      dispatch(initializeAsync())
    })

    return () => {
      EventBus.remove(PROFILE_SUCCESS, profileHandler)
      EventBus.remove(PROFILE_IMAGE_SUCCESS, profileImageHandler)
      EventBus.remove(AUTHENTICATION_LOGOUT_SUCCESS, logoutHandler)
    }
  },[])



  const [messageApi, contextHolder] = message.useMessage();
  const success = () => {
    messageApi.open({
      type: 'success',
      content: 'This is a success message',
    });
  };


  return (
    <Layout>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "white",
          textUnderlinePosition: "unset",
          position: "sticky",
          top: 0,
          zIndex: 1,
        }}
      >
        <Navbar/>
      </Header>
    	{/* <marquee bgcolor="red" className="text-white " loop="-1" scrollamount="2" width="100%">The site is in test mode</marquee> */}
      <Content>

          {contextHolder}
          {/* <Container fluid className="p-0"> */}
            <Outlet/>
            {/* <HeaderSlider/> */}
          {/* </Container> */}

        {/* <Container>
          <Row className="my-5">
            <h1 className="text-center">Collection</h1>
            <Col>
              <Segmented
                options={[
                  {
                    value: "List",
                    icon: <BarsOutlined />,
                  },
                  {
                    value: "Kanban",
                    icon: <AppstoreOutlined />,
                  },
                ]}
                value={shape}
                onChange={setShape}
              />
            </Col>
          </Row>

          <ProductList shape={shape}/>

        </Container> */}
      </Content>
      <Footer
        style={{
          backgroundImage: `url(${footBack})`,
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-around",
          height: "280px",
          width: "100%",
        }}
      >
        <Footers/>
      </Footer>
    </Layout>
  );
};
export default App;
